import React, {useState} from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import Format from '~/lib/format';
import {Dialog, FormNumberInput} from '~/components/controls';
import PropTypes from 'prop-types';

const QuantityDialog = ({initialValue, onChange, onDismiss}) => {
  const [value, setValue] = useState(initialValue);

  const onOK = (quantity) => {
    onChange(quantity);
    onDismiss();
  };

  return (
    <Dialog
      visible={true}
      title="Hoeveelheid"
      onDismiss={onDismiss}
      buttons={[
        {
          text: 'Annuleren',
          onPress: onDismiss,
        },
        {
          text: 'OK',
          onPress: () => onOK(value),
        },
      ]}>
      <View style={[sy['py-4']]}>
        <FormNumberInput
          label="Aantal"
          value={value}
          digits={2}
          onChangeNumber={(value) => {
            const quantity = Format.round(value, 2);
            setValue(quantity);
            return quantity;
          }}
          onSubmit={onOK}
        />
      </View>
    </Dialog>
  );
};
QuantityDialog.propTypes = {
  initialValue: PropTypes.any,
  onChange: PropTypes.any,
  onDismiss: PropTypes.any,
};


export default QuantityDialog;
